export default {
  methods: {
    // 跳转链接详情
    handleNavigateToList(menuId) {
      if (menuId)
        this.$router.push({
          name: "List",
          params: { menuId: menuId },
        });
    },
    // 跳转列表内容详情
    handleNavigateToDetail(contentId,title) {
      if (contentId !== undefined)
        this.$router.push({
          name: "Detail",
          params: { contentId: contentId,label:title},
        });
    },
    // 链接跳转
    handleNavigateToLink(item) {
      if(item.linkName=='头歌'){
        this.$router.push({
          path: "/touGe",
          query: {url: item.linkUrl,activeIndex:null }
          // params: { contentId: item.id,activeIndex:null }
        });
      }
      if (item?.linkUrl !== "/") {
        if (item.linkTarget == "_blank") {
          window.open(item?.linkUrl);
        } else {
          window.location.href = item?.linkUrl;
        }
      }
    },
  },
};
